import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BsApple, BsAndroid, BsLink } from "react-icons/bs";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        <Button variant="primary" href={props.demoLink} target="_blank">
          {!props.isWeb && <BsAndroid />} {props.isWeb && <BsLink />} &nbsp;
          {props.isWeb ? "Web" : "Android"}
        </Button>
        {"\n"}
        {"\n"}

        {props.isIos && (
          <Button
            variant="primary"
            href={props.iosLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <BsApple /> &nbsp;
            {"iOS"}
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
